import BaseApi from "./BaseApi";

export default class User extends BaseApi{
    construct() {}

    static async list(params) {
        let url = User.getApiUrl() + "complaint_admin";

        return User.getAxiosInstance().get(url,{params: params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/client/users/";
    }
}